/**
 * @generated SignedSource<<aa3d47e2b4e13f89abaa20fa77213c31>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type Currency = "AUD" | "CAD" | "CHF" | "DKK" | "EUR" | "GBP" | "JPY" | "MXN" | "NOK" | "SEK" | "USD" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type getCheckoutChargesCurrencyDisclaimer_transaction$data = {
  readonly buyer: {
    readonly hasSupportedChargeCurrency: boolean | null;
    readonly preferences: {
      readonly currency: Currency | null;
    } | null;
  } | null;
  readonly buyerChargeCurrency: Currency | null;
  readonly buyerInvoice: {
    readonly totalAmount: {
      readonly convertedAmountList: ReadonlyArray<{
        readonly amount: number | null;
        readonly currency: Currency | null;
      } | null> | null;
    } | null;
  } | null;
  readonly summary: {
    readonly checkoutPaymentAuthorization: {
      readonly authorizationAmount: {
        readonly convertedAmountList: ReadonlyArray<{
          readonly amount: number | null;
          readonly currency: Currency | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
  readonly uiMessages: {
    readonly foreignExchangeDisclaimer: string | null;
  } | null;
  readonly " $fragmentType": "getCheckoutChargesCurrencyDisclaimer_transaction";
};
export type getCheckoutChargesCurrencyDisclaimer_transaction$key = {
  readonly " $data"?: getCheckoutChargesCurrencyDisclaimer_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"getCheckoutChargesCurrencyDisclaimer_transaction">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "getCheckoutChargesCurrencyDisclaimer_transaction"
};

(node as any).hash = "0d7f5b2e5f34bd526f66e94ab640edf4";

export default node;
